import { createContext } from 'react'

const DataProcessOptionsContext = createContext()

export default DataProcessOptionsContext
